<template>
  <div class="mb-0 overflow-visible">
    <RemoteResponsiveImage
      :product-image-data="item.ingredient.images[0]?.data"
      img-class="w-100 h-auto image-contain"
      :alt="item.ingredient.name"
      sizes="10vw"
    />
    <!-- amount -->
    <span
      v-if="item.amount > 1"
      class="inline-block p-2 md:p-3 absolute  bottom-0 right-0 mr-1 bg-warning rounded-circle"
    >
      <span class="absolute centered text-sm text-white leading-1">{{ item.amount }}</span>
    </span>

    <transition name="fade">
      <div
        v-if="itemIndex === hoveredIndex"
        class="mixes-bottom-bar__btns flex"
      >
        <ButtonMinus
          class="relative btn  btn-muffled p-2 rounded-pill border-0"
          aria-label="Odebrat"
          icon-size="20"
          @click="decreaseMixItem"
        />
        <ButtonPlus
          v-if="!item.ingredient.isBase"
          class="relative"
          aria-label="Add"
          icon-size="20"
          @click="increaseMixItem"
        />
      </div>
    </transition>
  </div>
</template>

<script setup>
import ButtonMinus from '@/components/buttons/ButtonMinus.vue'
import ButtonPlus from '@/components/buttons/ButtonPlus.vue'
import RemoteResponsiveImage from '@/components/general/BaseRemoteResponsiveImage.vue'
import { MixService } from '@/services/mixService'

const props = defineProps({
  kind: {
    type: String,
    required: true,
  },

  item: {
    type: Object,
    required: true,
  },

  hoveredIndex: {
    type: String,
    required: true,
  },

  itemIndex: {
    type: String,
    required: true,
  },
})

const increaseMixItem = () => {
  const mixService = new MixService(props.kind)
  mixService.addIngredient({ ingredient: props.item.ingredient, quantity: 1 })
}

const decreaseMixItem = () => {
  const mixService = new MixService(props.kind)
  mixService.removeIngredient({ ingredient: props.item.ingredient, quantity: 1 })
}
</script>
